import { useAuth0 } from "@auth0/auth0-react";
import { ContentDeliveryClientV3 } from "../auto-generated-clients/content-delivery-client-v3.generated";
import { useAppConfig } from "rwo-react";

let contentDeliveryClientV3: ContentDeliveryClientV3 | undefined;

export const useContentDeliveryServiceV3 = (): ContentDeliveryClientV3 => {
  const { getAccessTokenSilently } = useAuth0();
  const { config } = useAppConfig();

  if (!contentDeliveryClientV3) {
    contentDeliveryClientV3 = new ContentDeliveryClientV3(
      `${config.BackendAddress}${config.CDSV3ApiSuffix}`
    );
  }

  contentDeliveryClientV3.setAccessToken(getAccessTokenSilently());

  return contentDeliveryClientV3;
};  